export const tooltipTheme = {
  root: {
    borderRadius: 'var(--border-radius)',
  },
  padding: 'var(--half-rem) var(--half-rem)',
  extend: {
    agility: {
      fontSize: 'var(--font-size-sm)',
    },
  },
  colorScheme: {
    light: {
      root: {
        background: 'var(--text-color)',
        color: 'var(--white)',
        shadow: 'var(--overlay-box-shadow)',
        borderColor: 'var(--p-primary-400)',
      },
    },
    dark: {
      root: {
        background: 'var(--p-surface-50)',
        color: 'var(--p-surface-900)',
        shadow: 'var(--overlay-box-shadow)',
        borderColor: 'var(--p-primary-400)',
      },
    },
  },
  css: ({ dt }: any) => `
  .p-tooltip .p-tooltip-text {
    font-size: var(--font-size-sm);
  }
  `,
};
